import React, { useEffect, useState, useMemo } from 'react';
import {
  Box,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  Badge,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/Store';
import { useStationBadgeCount } from '../../utils/helpers/formatValue';
import {
  AuditStateQuestion,
  MobileStateItemBase,
  MobileStateQuestion,
} from '@safeguardproperties/corescript-react-npm/dist/types';

import {
  getScriptSave,
  getScriptState,
  getScriptData as getCorescriptData,
} from '../../redux/reducer/coreScriptReducer';
import CustomTypography from '../../ui/atoms/CustomTypography';

interface SidePanelProps {
  onNavigateToStation: (index: number) => void;
  onClose: () => void; // Add the onClose prop
  expanded?: boolean;
}

const SidePanel: React.FC<SidePanelProps> = ({
  onNavigateToStation,
  onClose,
  expanded,
}) => {
  const stateData = useSelector(getScriptState);
  const stations = stateData?.Stations ?? [];
  const handleNavigateToStation = (station: any) => {
    const stationIndex = stations.findIndex((s) => s.title === station.title);
    if (stationIndex !== -1) {
      onNavigateToStation(stationIndex); // Call the scroll function
    }
  };

  return (
    <Box
      sx={{
        height: '100%',
        maxWidth: expanded ? '100%' : '300px',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <List>
        {stations.map((station) => (
          <ListItem
            key={station.title}
            onClick={() => handleNavigateToStation(station)}
          >
            <SidePanelCount station={station}></SidePanelCount>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

interface SidePanelCountProps {
  station: any;
}

const SidePanelCount: React.FC<SidePanelCountProps> = ({ station }) => {
  const stateData = useSelector(getScriptState);
  const badgeCount = useStationBadgeCount(
    station.data as
      | MobileStateItemBase[]
      | MobileStateQuestion[]
      | AuditStateQuestion[]
  );

  return (
    <CustomTypography
      variant='h5'
      sx={{
        color: '#343330',
        fontFamily: 'Montserrat',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: '600',
        textTransform: 'capitalize',
        lineHeight: '21.94px',
        textAlign: 'left',
        textUnderlinePosition: 'from-font',
        textDecorationSkipInk: 'none',
      }}
    >
      {station.title?.toLanguagePack()}
      {badgeCount > 0 && (
        <Box
          component='span'
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '20px',
            height: '20px',
            backgroundColor: '#F35625',
            borderRadius: '50%',
            color: '#fff',
            fontSize: '11px',
            marginLeft: '8px',
            position: 'absolute',
            top: '15%',
          }}
        >
          {badgeCount}
        </Box>
      )}
    </CustomTypography>
  );
};

export default SidePanel;
